import script from "./4F30.vue?vue&type=script&setup=true&lang=js"
export * from "./4F30.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__